import React, { useState } from 'react';
import Instructions_02_03_CTRF from "./Instructions_02_03_CTRF.pdf";
import Devoir_Vigilance from "./Devoir_Vigilance.pdf";
import Obligations_Assujetis_Assurance from "./Obligations_Assujetis_Assurance.pdf";
import Autoevaluataion_LD01 from "./Lignes_Directrices_1_01juin2025CSA.pdf";
import Autoevaluataion_LD02 from "./Lignes_Directrices_2_01juin2025CSA.pdf";
import LD_Blanchiment_PADF from "./LD_Lutte_contre_blanchiment_argent_financement_terrorisme_PADM.pdf";
import CND_Autoris_PDG_ASS_REASS from "./Conditions_Autorisation_dirigeants_Societe_Assurance_Reass_Assujetties.pdf";
import Button from "react-bootstrap/Button";

function Homebtnpdf() {
  // Declare state for tracking hover status
  const [hovered_CASH, setHovered_CASH] = useState(false);

  // Functions to handle mouse enter and leave events
  const handleMouseEnter = () => setHovered_CASH(true);
  const handleMouseLeave = () => setHovered_CASH(false);

  return (
    <div style={{ display:"bloc",marginLeft:"30%",  gap: "15px", paddingBottom: "10px"}}>
       <h6>
        Documents
       </h6>
        <a
          href={Instructions_02_03_CTRF}
          target="_blank"
          rel="noreferrer"
          style={{
            color: "#000000",
            fontSize: "12px",
            textDecoration: "none",
          }}
        >
         1- Instructions CTRF
          <br>
          </br>
        </a>
            
        <a
          href={Devoir_Vigilance}
          target="_blank"
          rel="noreferrer"
          style={{
            color: "#000000",
            fontSize: "12px",
            textDecoration: "none",
          }}
        >
          2- Devoir Vigilance
          <br>
          </br>
        </a>
          
        <a
          href={Obligations_Assujetis_Assurance}
          target="_blank"
          rel="noreferrer"
          style={{
            color: "#000000",
            fontSize: "12px",
            textDecoration: "none",
          }}
        >
          3- Obligations Assujetis Assurance
          <br>
          </br>
        </a>

        <a
          href={Autoevaluataion_LD01}
          target="_blank"
          rel="noreferrer"
          style={{
            color: "#000000",
            fontSize: "12px",
            textDecoration: "none",
          }}
        >
          4- Autoevaluataion des risques -Lignes Directrices 01 
          <br>
          </br>
        </a>
        <a
          href={Autoevaluataion_LD02}
          target="_blank"
          rel="noreferrer"
          style={{
            color: "#000000",
            fontSize: "12px",
            textDecoration: "none",
          }}
        >
          5- Autoevaluataion des risques -Lignes Directrices 02 
          <br>
          </br>
        </a>
        <a
          href={LD_Blanchiment_PADF}
          target="_blank"
          rel="noreferrer"
          style={{
            color: "#000000",
            fontSize: "12px",
            textDecoration: "none",
          }}
        >
          6- Lignes Directrices en matière de lutte contre le blanchiment argent
          <br>
          </br>
        </a>

        <a
          href={CND_Autoris_PDG_ASS_REASS}
          target="_blank"
          rel="noreferrer"
          style={{
            color: "#000000",
            fontSize: "12px",
            textDecoration: "none",
          }}
        >
          7- Conditions Autorisation dirigeants Société Assurance Reass Assujetties
          <br>
          </br>
        </a>





      
    </div>
  );
}

export default Homebtnpdf;

